{
  "styleGuide": {
    "title": "Style Guide",
    "subtitle": "Lorem ipsum"
  },
  "guaranteeOrderList": {
    "title": "Lista zleceń"
  },
  "guaranteeOrder": {
    "title": "Zlecenie"
  },
  "error": {
    "pageNotFound": {
      "title": "404 - Nie znaleziono strony o podanym adresie"
    }
  },
  "loggedOut": {
    "title": "Wylogowany",
    "line1": "Zostałeś wylogowany z systemu.",
    "line2": "Trwa przekierowywanie na portal PB24..."
  }
}
